import { BeatLoader, MoonLoader } from 'react-spinners';

type Props = {
	size: number;
	type: 'beat-loader' | 'circle';
	loading: boolean;
	parentClass?: string;
	className?: string;
};

const Loading = ({ size, type, loading, parentClass = '', className = '' }: Props) => {
	return (
		<div className={`flex gap-2 items-center justify-center ${type === 'beat-loader' && 'flex-col'} ${parentClass}`}>
			{type === 'beat-loader' ? (
				<BeatLoader
					cssOverride={{ display: 'block' }}
					className={className}
					color='#F87315'
					loading={loading}
					size={size}
				/>
			) : (
				<MoonLoader
					cssOverride={{ display: 'block' }}
					className={className}
					color='#F87315'
					loading={loading}
					size={size}
				/>
			)}
			Mohon tunggu...
		</div>
	);
};

export default Loading;
